import React from 'react'
import PropTypes from 'prop-types'

function WhatsNewPanel ({ onDismiss }) {
  return (
    <div className={'left-panel panel-whatsNew'}>
      <div className='title'>
        What's new in NetFinder?
      </div>
      <div className='text'>
        We are updating the way we describe the organizations we track.
        <br />
        <ul>
          <li>“Sites” will now be referred to as “Offices”, with each “Office” representing one location within an organization.</li>
          <li>“Companies” will remain as is – grouping together all the “Offices” that are part of one organization.</li>
        </ul>
        <b>Where’s my donuts ?</b>
        <br />Circles to rectangles – look just a little further down in the results section
      </div>
      <button onClick={onDismiss} className='loginBtn news'>
        Dismiss
      </button>
    </div>
  )
}

WhatsNewPanel.propTypes = {
  onDismiss: PropTypes.func
}

export default WhatsNewPanel
